<template>
    <div>
    <TextBanner>
        Das <strong>größte bewegliche Bauwerk der Welt</strong>
        könnte fast die ganze <strong>Elbphilharmonie</strong> einpacken.
    </TextBanner>
    
        <Fallback>
            <picture>
                <source media="(orientation: portrait)" srcset="../assets/img/fallback/09_Elbphilharmonie_iPad_P.jpg">
                <source media="(orientation: landscape)" srcset="../assets/img/fallback/09_Elbphilharmonie_iPad_L.jpg">
                <!-- The img element is required as the last child tag of the picture declaration block. The img element is used to provide backward compatibility for browsers that do not support the picture element, or if none of the source tags matched. -->
                <img src="../assets/img/fallback/Infobox.png" alt="">
            </picture>          
        </Fallback>

    </div>
</template>



<script>
    export default {
        name: 'Elbphilharmonie',
        babylonState: {
            moveCamera: [-7.2, 1.50, 8, 27.4 ,0.5,1.3],    


            Geo_Tschernobyl: {

                children: {
                    
                    BG_Sphere: true,
                    
                    Geo_Beton_Sarkophag: false,
                    Geo_Beton_Sarkophag_Rost: true,
                    Geo_Schattenplane_Betonsarkophag: true,
                    Geo_Textur1_Reaktor_4_Damage: false,
                    Geo_Textur1_Reaktor_4_Damage_Aussen: false,
                    Geo_Textur1_Reaktor_4_Damage_Innen: false,

                    Geo_Neuer_Sarkophag_anim: false,

                    Geo_Neuer_Sarkophag_startpos_transparent: true,

                    Geo_Schienen_Sarkophag: true,
                    Geo_Schattenplane_NSC_startpos: true,

                    Geo_Elbphilharmonie_Basis: true,
                    Geo_Elbphilharmonie_Dach: true,
                    Geo_Elbphilharmonie_Glas: true,
                    Geo_Elbphilharmonie_Mitte: true,
                    Geo_Elbphilharmonie_Sockel: true, 

                    Geo_GrosserTurm_Gestaenge1: true,
                    Geo_GrosserTurm_Schlot1: true,
                    Geo_GrosserTurm_RoteStreifen1: true,
                    Geo_GrosserTurm_Schattenplane: true,

                    Geo_KleinerTurm_Geruest1: false,
                    Geo_KleinerTurm_Schlot1: false,
                    Geo_KleinerTurm_RoteStreifen1: false,
                    Geo_KleinerTurm_Schattenplane: false, 
                            

                },

            },

            fire: false
        },

        babylonReady: function () {

            //this.$audioController.initTrack('speaker', require('./../assets/audio/Uebergang_01.mp3'), false, true);
            
            this.$babylonController.setAutoRotateBehaviour(true),
            this.$babylonController.setCameraRadiusLimit (5.7,50),
            this.$babylonController.zoomCamera(1.6)
            
        },

    }
</script>

<style scoped lang="scss">

    .fallback-container .hotspot {
        
        left: 65vw;
        top: 40vh;

        @media (orientation: landscape) {
            left: 60vw;
            top: 35vh;
            transform: scale(0.75);            
        }
    }


</style>
